<div class="steps mb-3">
  <div
    class="step-item"
    *ngFor="let step of steps; let i = index"
    [class.is-completed]="step.state === 'completed'"
    [class.is-active]="step.state === 'active'"
    [class.is-failed]="step.state === 'error'"
    [class.is-muted]="step.state === 'muted'"
  >
    <div class="step-marker">
      <span class="icon has-text-weight-normal" [ngSwitch]="step?.state">
        <span *ngSwitchCase="'active'">{{ validateRedirection(i) }}</span>
        <span *ngSwitchCase="'normal'">{{ validateRedirection(i) }}</span>
        <em *ngSwitchCase="'error'" class="pointer mdi mdi-close mdi-18px"></em>
        <em *ngSwitchDefault class="pointer mdi mdi-check mdi-18px"></em>
      </span>
    </div>
    <div class="step-details is-primary">
      <p
        class="step-title pt-1"
        [class.has-text-link]="step.state === 'active'"
        [class.has-text-primary]="step.state === 'completed'"
      >
        {{ step?.title | translate }}
      </p>
    </div>
  </div>
</div>
